import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import type { ApprovalUser, FetchApprovalUsersResponse } from 'vopay';

const { api } = vopayApi;

export default function useFetchApprovalUsers() {
  const source = axios.CancelToken.source();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<ApprovalUser[]>([]);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchApprovalUsers(): Promise<FetchApprovalUsersResponse> {
    try {
      setLoading(true);

      const res = await api.fetchApprovalUsers(source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setUsers(res.Users);
      return res;
    } catch (err) {
      console.error('Fetch approval users failed:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    response: users,
    fetchApprovalUsers,
  };
}
